import { Alert } from '../primitives/alert.js'
import React, { type FC } from 'react'
import styles from './alert-error.module.css'

export interface AlertErrorProps {
  error: unknown

  children?: React.ReactNode
}

const parseError = (error: unknown): string => {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return error.message as string
  }
  if (typeof error === 'object' && error !== null && 'data' in error && error.data instanceof Uint8Array) {
    return new TextDecoder().decode(error.data)
  }

  if (error instanceof Error) {
    return error.stack ?? error.message
  }

  return 'An error occurred.'
}

export const AlertError: FC<AlertErrorProps> = props => {
  const { children, error } = props

  const errorMessage = parseError(error)

  return (
    <Alert severity="error">
      <div className={styles.children}>{children}</div>

      <code className={styles.code}>{errorMessage}</code>

      <p className={styles.contact}>
        This is our fault. Please reach out to us at <a href="mailto:support@tunasong.com">support@tunasong.com</a>.
      </p>
    </Alert>
  )
}

export default AlertError
